import { gql } from '@apollo/client';

export const CREATE_ROL = gql`
    mutation CreateRol(
        $descripcion: String!
        $idFuncion: Int!
        $idTipoProfesional: Int!
        $listaPantallas: [PantallaRolInput!]!
        $listaNotificaciones: [NotificacionRolInput!]!
        $listaKpis: [KpiRolModelInput!]!
        $listaRolesNoCompatibles: [RolNoCompatibleInput!]!
        $listaConsultaRol: [ConsultaRolEntradaInput!]!
    ) {
        saveRol(
            model: {
                descripcion: $descripcion
                idFuncion: $idFuncion
                idTipoProfesional: $idTipoProfesional
                listaPantallas: $listaPantallas
                listaNotificaciones: $listaNotificaciones
                listaKpis: $listaKpis
                listaRolesNoCompatibles: $listaRolesNoCompatibles
                listaConsultaRol: $listaConsultaRol
            }
        ) {
            success
            error
            valorEsperado
        }
    }
`;

export const adaptListaConsultaRolInput = (data) => {
    return data?.map((consulta) => ({
        idConsulta: consulta.idConsulta,
        dataPrivacy: !!consulta.dataPrivacy
    })) || [];
}